import React from "react";
import "./input-disclaimer.scss";

const InputDisclaimer = ({ children }) => {
  return <div className="InputDisclaimer">{children}</div>;
};

export default InputDisclaimer;
